module.exports = __webpack_public_path__ + "00e9c7b12de4d5b1334d7f5f664c19d2.jpg";